import { forwardRef } from 'react';
import type { BasicInputProps } from '../basic-input';
import { BasicInput } from '../basic-input';

type EmailInputProps = Omit<BasicInputProps, 'type'>;

export const EmailInput = forwardRef<HTMLInputElement, EmailInputProps>(
  (props, ref) => <BasicInput ref={ref} type="email" {...props} />
);

EmailInput.displayName = 'EmailInput';
